import styled from 'styled-components'
import { ResponsiveImage } from '@velasca/ui/responsive-image'
import { SansTitle } from '@velasca/ui/sans-title'

export const Background = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
`

export const Container = styled.div`
  padding: 4.5rem 1.2rem;

  @media screen and (min-width: 992px) {
    padding: 6rem 3rem;
  }
`

export const Grid = styled.div`
  display: grid;

  width: 100%;
  gap: 0.5rem;
  margin: 0.5rem auto auto auto;
  grid-template-columns: repeat(2, 1fr);

  @media screen and (min-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
    margin-top: 2rem;
    gap: 1rem;
  }
`

export const ImageContainer = styled.div`
  width: 100%;

  .safari-lower-than-15 & {
    margin-bottom: 1.6rem;
    position: relative;
    padding-top: 125%;
  }
`

export const Image = styled(ResponsiveImage)`
  height: 100%;
  aspect-ratio: 4/5;
  object-fit: cover;

  .safari-lower-than-15 & {
    position: absolute;
    top: 0;
  }
`
export const CollectionCardTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 1rem;
  margin-top: 2rem;

  & > * {
    font-size: 1.4rem;
  }

  @media screen and (min-width: 992px) {
    & > * {
      font-size: 2rem;
    }
  }
`

export const CollectionCardWrapper = styled.a`
  margin-bottom: 1rem;

  @media screen and (min-width: 992px) {
    margin-bottom: 3.5rem;
  }

  &:hover {
    ${SansTitle} {
      color: ${({ theme }) => theme.colors.primary};
      text-decoration: underline;
      text-decoration-thickness: 0.1rem;
      text-underline-offset: 0.3rem;
    }
    .pathArrow {
      stroke: ${({ theme }) => theme.colors.primary};
    }
  }
`
